define( function() {
	"use strict";

	return ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/pnum.js
// module id = 80
// module chunks = 27